import React from 'react';
import classNames from 'classnames';
import Link from 'next/link';
import LogoWithText from '@/business-components/LogoWithText';
import styles from './index.module.scss';

export default function FilterBrand({ data, onClose }) {
  return (
    <div className={classNames('flex-row-wrap', 'flex-start-center', styles.filterBrand)}>
      {data?.map((item, index) => (
        <div key={index} className={styles.filterBrandItem}>
          {data?.length > 1 && (
            <div className={styles.filterBrandItem__close} onClick={() => onClose(item.conBrandId, item)}>
              取消对比
            </div>
          )}
          <div>
            <Link href={`/brand/${item.conBrandId}`} key={item.conBrandId}>
              <a
                target={'_blank'}
                className={classNames('flex-row-nowrap', 'flex-start-center', styles.filterBrandItemBox)}
              >
                <LogoWithText
                  src={item?.logoUrl}
                  width={48}
                  borderRadios={12}
                  chName={item?.chName}
                  ehName={item?.ehName}
                  logoClass={styles.filterBrandItem__img}
                  spanClass={styles.logoSpan}
                  len={4}
                />
                {/*<img src={item?.logoUrl} className={styles.filterBrandItem__img} />*/}
                <div className={styles.filterBrandItem__content}>
                  <div className={classNames('flex-row-nowrap', 'flex-start-center')}>
                    <div className={styles.filterBrandItem__brandName}>{item?.chName}</div>
                    {!item?.hasUnlocked && <span className={styles.filterBrandItem__brandLabel}>未解锁</span>}
                  </div>
                  <div
                    className={classNames('flex-row-nowrap', 'flex-start-center', styles.filterBrandItem__brandType)}
                  >
                    <div className={styles.filterBrandItem__brandIndustry}>
                      {item?.industryTrackName}
                      {/* <div className={styles.filterBrandItem__brandTrack}> */}
                      &nbsp;|&nbsp;{item?.oneLevelTrackName}
                    </div>
                  </div>
                </div>
              </a>
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
}
